import { render } from "./volume.vue?vue&type=template&id=e4483cf2"
import script from "./volume.vue?vue&type=script&lang=js"
export * from "./volume.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__